export default __webpack_public_path__ + "static/media/ThanosSnap.5d6421af.gif";